
/**
 * messageBox 弹窗
 * @description 弹出层容器，用于展示弹窗、信息提示等内容
 * @property {Boolean} visibale 打开popup（默认false)
 * @property {Boolean} showMask 显示蒙层（默认)
 * @property {Boolean} content 用户自定义文字
 * @property { String} title 标题
 * @property { String} message 消息内容
 * @property { String} cancelText 取消按钮文字
 * @property { String} confirmText 确认按钮文字
 * @property {Object} config 用户自定义样式
 * @property { String} border-radius 弹窗圆角值（默认10px）
 * @property { String} z-index 弹出内容的z-index值（默认100）
 * @property { String} width 弹出内容的width值（默认600）
 * @property { String} height 弹出内容的height值（默认250）
 * @event {Function} open 弹出层打开
 * @event {Function} close 弹出层收起
 * @event {Function} maskClick 蒙层点击
 */
export default {
  name: "MessageBox",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    showMask: {
      type: Boolean,
      default: true
    },
    styleConfig: {
      type: Object,
      default: () => {
        // text:'',
        // background:'',
        // customClass:"",
      }
    },
    disMaskClick: {
      type: Boolean,
      default: false
    },
    content: {
      type: Object,
      default: () => {
        // title:'',
        // message:'',
        // cancelText:'',
        // confirmText:""
      }
    },
    showButton: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      popShow: false,
      defaultData: {
        title: "我是title",
        message: "我是 message",
        cancelText: "取消",
        confirmText: "确认",
        showCancel: true,
        showConfirm: true,
        showClose: true
      },
      callback: null
    }
  },
  computed: {
    contentData() {
      return { ...this.defaultData, ...this.content }
    }
  },
  watch: {
    visible: {
      handler(newVal, old) {
        this.popShow = newVal
      },
      immediate: true
    }
  },
  mounted() {},
  methods: {
    open() {
      this.popShow = true
    },
    close() {
      this.popShow = false
      this.$emit("close")
    },
    confirm() {
      this.popShow = false
      this.$emit("confirm")
      if (this.callback) {
        this.callback("confirm")
      }
    },
    cancel() {
      this.popShow = false
      this.$emit("cancel")
      if (this.callback) {
        this.callback("cancel")
      }
    },
    maskClick() {
      if (!this.disMaskClick) {
        this.popShow = false

        this.$emit("maskClick")
      }
    }
  }
}
